import { render, staticRenderFns } from "./yycChuKuDan.vue?vue&type=template&id=4c36ffe2&scoped=true&"
import script from "./yycChuKuDan.vue?vue&type=script&lang=js&"
export * from "./yycChuKuDan.vue?vue&type=script&lang=js&"
import style0 from "./yycChuKuDan.vue?vue&type=style&index=0&id=4c36ffe2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c36ffe2",
  null
  
)

export default component.exports